import React, { useEffect, useContext, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams, useHistory, Redirect } from 'react-router-dom';
import ProgressFullscreen from '../components/common/ProgressFullscreen';
import PpsiForm from '../components/PpsiForm';
import _ from 'lodash';
import has from 'lodash/has';
import { Mode } from '../components/PpsiForm/constants';
import {
  getLanguage,
  getMarketLanguage,
  getReviewMarket,
  getMarketConfig,
  fetchingMarketConfig
} from '../features/app/selectors';
// import useReviewPpsi from '../features/PpsiContainer/hooks/usePpsi';
import { transformRejectDataToApiFormat } from 'components/Prompt/Content/GlobalApprovalRejectComment';
import getApprovalSteps from '../features/PpsiContainer/approvalSteps/approvalSteps';
import PromptContext from '../components/Prompt/PromptContext';
import useReviewPpsi from 'features/PpsiContainer/hooks/useReviewPpsi';
import useCreateDraftPpsi from '../features/PpsiContainer/hooks/useCreateDraftPpsi';
import useUtensils from '../features/UtensilContainer/hooks/useUtensils';
import { ppsiInProgressRoute, globalMarketReviewRoute } from '../routes';
import usePpisRelatedToPpsi from '../features/PpiContainer/hooks/usePpisRelatedToPpsi';
import {
  useUnpublishPpsi,
  useGlobalApprovePpsi,
  useGlobalRejectPpsi
} from '../features/PpsiContainer/hooks/usePpsiAction';

import {
  hasRecalledPPSIError,
  fetchGlobalApprovalPpsi,
  fetchGlobalPpsi
} from 'features/PpsiContainer/actions';
import {
  getHasRecalledError,
  getGlobalApprovalPpsi,
  getPpsiById
} from 'features/PpsiContainer/selectors';

import { getMarketConfigs } from 'features/app/actions';

import {
  fetchGlobalPpis,
  fetchMarketPpis
} from 'features/PpiContainer/actions';
import useMarketPpis from 'features/PpiContainer/hooks/useMarketPpis';
import View from './views';
import usePpis from 'features/PpiContainer/hooks/usePpis';
import usePpsi from '../features/PpsiContainer/hooks/usePpsi';
import usePpisRelatedToMarket from 'features/PpiContainer/hooks/usePpisRelatedToMarket';
import {
  getMarketUtensils,
  getFetching
} from 'features/UtensilContainer/selectors';
import { fetchMarketUtensils } from 'features/UtensilContainer/actions';

import { getIsGlobalUser } from 'features/loginSystem/selectors';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText
} from '@material-ui/core';
import { toJS } from 'utils/immutableUtils';
import { getPpisAll } from 'features/PpiContainer/selectors';
import useGlobalPublishedPpiIfs from 'features/PpsiContainer/hooks/useGlobalPublishedPpiIfs';

function getData(ppsi) {
  let data = _.cloneDeep(ppsi.inProgressPpsiEnrichmentData);
  const dish = has(data, 'referencedIFoodData') ? data.referencedIFoodData : {};
  data = {
    ...data,
    ppsiId: ppsi.id,
    dish
  };
  return data;
}

const PpsiGlobalApprovalView = () => {
  const { id } = useParams();
  const history = useHistory();
  const dispatch = useDispatch();
  const market = useSelector(getReviewMarket);
  const hasRecalledError = useSelector(getHasRecalledError);
  const isGlobalUser = useSelector(getIsGlobalUser);
  const [isFetchingPpsi, ppsi, fetchPpsiError] = useReviewPpsi(id, {
    forceFetch: true
  });
  const isFetchingConfig = useSelector(fetchingMarketConfig);
  const isFetchingUtensils = useSelector(getFetching);
  const { open: openPrompt } = useContext(PromptContext);
  const [approveGlobalReviewPpsi, isGlobalApproving] = useGlobalApprovePpsi();
  const [rejectGlobalReviewPpsi, isGlobalRejecting] = useGlobalRejectPpsi();

  const localMarket = JSON.parse(localStorage.getItem('localMarket'));
  const [isFetchingRelatedPpis] = usePpisRelatedToMarket(localMarket, id);
  // const activeLanguage = useSelector(getLanguage);
  // const getGlobalApprovalPpsis = useSelector(getGlobalApprovalPpsi).toJS();
  const reviewMarket = useSelector(getReviewMarket);
  // const ppis = useSelector(getPpisAll);
  // const utensils = useSelector(getMarketUtensils).toJS();
  // const reviewMarketLanguage = useSelector(getMarketLanguage);
  // const marketConfig = useSelector(getMarketConfig).toJS();
  const [glbalPpsiId, setGlobalPPsiId] = useState(null);
  const globalPpsi = useSelector(getPpsiById(glbalPpsiId));
  const [isFetchingGlobalPpiIfs, getGlobalId] = useGlobalPublishedPpiIfs();

  const prevParentPpsiIdRef = useRef(null);
  useEffect(() => {
    if (ppsi && ppsi.inProgressPpsiEnrichmentData) {
      // console.log(ppsi.inProgressPpsiEnrichmentData, 'first if');
      const newParentPpsiId = ppsi.inProgressPpsiEnrichmentData.parentPpsiId;
      if (newParentPpsiId && newParentPpsiId !== prevParentPpsiIdRef.current) {
        // console.log(ppsi.inProgressPpsiEnrichmentData, 'second if');
        setGlobalPPsiId(newParentPpsiId);
        dispatch(fetchGlobalPpsi(newParentPpsiId));
        getGlobalId(newParentPpsiId);
        prevParentPpsiIdRef.current = newParentPpsiId;
      }
    }
  }, [dispatch, ppsi]);
  // useEffect(() => {
  //   // Only fetch global dishes if context user is local user (service office)

  //   dispatch(fetchGlobalPpis());
  // }, [dispatch]);

  // console.log(fromPpsiRaw,"fromPpsiRawfromPpsiRaw")
  const fromPpsi = toJS(globalPpsi);
  // const globalPpis = toJS(ppis, []);
  const marketLanguage = JSON.parse(localStorage.getItem('marketLanguage'));

  const isFetchings =
    isFetchingPpsi || isFetchingRelatedPpis || isFetchingGlobalPpiIfs;

  useEffect(() => {
    if (reviewMarket === null) {
      dispatch(getMarketConfigs(localMarket));
    }

    dispatch(fetchMarketUtensils(localMarket));
    // if(utensils.length ===0) {
    // }
  }, []);

  if (fetchPpsiError) {
    throw fetchPpsiError;
  }

  if (isFetchings || isFetchingConfig || isFetchingUtensils) {
    return <ProgressFullscreen open />;
  }

  const ppsis = getData(ppsi);

  // console.log(ppsis,"ppsis")

  if (ppsis.status !== 'GLOBAL REVIEW') {
    return <Redirect to={globalMarketReviewRoute(localMarket)} />;
  }

  View.GlobalApproval.visit(ppsi, marketLanguage);

  const useMarketLanguage = ppsis.status === 'GLOBAL REVIEW' && isGlobalUser;

  function handleGlobalReject(ppsis) {
    const steps = getApprovalSteps(ppsis);

    const approve = approvalData => {
      rejectGlobalReviewPpsi(id, approvalData);
    };
    const onDone = ({ promptState }) => {
      const approvalData = transformRejectDataToApiFormat(promptState);
      const submitData = approvalData.globalRejectComment;
      approve(submitData);
    };

    if (steps.length > 0) {
      openPrompt({ steps, data: ppsis, onDone });
    } else {
      approve();
    }
  }

  function handleGlobalApprove() {
    approveGlobalReviewPpsi(localMarket, id);
  }
  return (
    <>
      <PpsiForm
        data={ppsis}
        dataLabels={{
          title: (data, { language }) =>
            data.info &&
            data.info[language] &&
            data.info[language].presentationName,
          status: () => ppsi.inProgressPpsiEnrichmentData.status,
          modifiedBy: 'lastModifiedBy',
          modifiedDate: 'modifyDate'
        }}
        showProgress={isGlobalApproving || isGlobalRejecting}
        onGlobalApprovePpsi={handleGlobalApprove}
        onGlobalRejectPpsi={handleGlobalReject}
        useMarketLanguage={useMarketLanguage}
        mode={Mode.READ}
        completePpsiData={ppsi}
        globalData={fromPpsi}
        // globalPpsis={globalPpsis}
        // globalPpis={globalPpis}
      />

      <Dialog open={hasRecalledError}>
        <DialogContent>
          <DialogContentText component="div">
            Sorry, but you can't Approve/Reject this PPSI. <br />
            PPSI is recalled and edited by Market Admin.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            key="stay"
            onClick={() => {
              history.push(globalMarketReviewRoute(localMarket));
              dispatch(hasRecalledPPSIError(false));
            }}
            color="primary"
            style={{ marginRight: '10px' }}
          >
            BACK TO THE LIST
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default PpsiGlobalApprovalView;
